<template>
  <div>
    <div class="page-header"><h2><span class="breadcrumb-level">宠物中心</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">宠物管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">入园登记表管理</span></h2><div class="header-actions"><el-input v-model="searchQuery" placeholder="搜索宠物名" clearable prefix-icon="Search" style="width:180px" @input="fetchData"/><el-select v-model="filterSpeciesId" placeholder="品类筛选" clearable style="width:130px" @change="fetchData"><el-option v-for="s in species" :key="s.id" :label="s.name" :value="s.id"/></el-select></div></div>
    <el-table :data="list" stripe v-loading="loading">
      <el-table-column label="宠物姓名" prop="name" min-width="100"/>
      <el-table-column label="品类" width="80"><template #default="{row}">{{row.species?.name||'-'}}</template></el-table-column>
      <el-table-column label="性别" width="60"><template #default="{row}">{{row.gender||'-'}}</template></el-table-column>
      <el-table-column label="生日" width="110"><template #default="{row}">{{formatDate(row.birthday)}}</template></el-table-column>
      <el-table-column label="绝育" width="60"><template #default="{row}"><el-tag :type="row.is_neutered?'success':'info'" size="small">{{row.is_neutered?'是':'否'}}</el-tag></template></el-table-column>
      <el-table-column label="创建人" width="80"><template #default="{row}">{{row.user_id||'-'}}</template></el-table-column>
      <el-table-column label="创建时间" width="150"><template #default="{row}">{{formatDate(row.created_at)}}</template></el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template #default="{row}"><el-button size="small" @click="showDetail(row)">详情</el-button></template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />

    <el-dialog v-model="detailDialog" title="入园登记详情" width="800px">
      <template v-if="detail.id">
        <!-- 基础信息 -->
        <h4 style="margin:0 0 12px;color:#606266">基础信息</h4>
        <el-descriptions :column="3" border style="margin-bottom:24px">
          <el-descriptions-item label="宠物姓名">{{detail.name}}</el-descriptions-item>
          <el-descriptions-item label="性别">{{detail.gender||'-'}}</el-descriptions-item>
          <el-descriptions-item label="头像"><el-image v-if="detail.avatar" :src="detail.avatar" style="width:48px;height:48px;border-radius:50%" fit="cover"/><span v-else>-</span></el-descriptions-item>
          <el-descriptions-item label="品类">{{detail.species?.name||'-'}}</el-descriptions-item>
          <el-descriptions-item label="品种">{{detail.breed?.name||'-'}}</el-descriptions-item>
          <el-descriptions-item label="生日">{{formatDate(detail.birthday)}}</el-descriptions-item>
          <el-descriptions-item label="绝育"><el-tag :type="detail.is_neutered?'success':'info'" size="small">{{detail.is_neutered?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="发情期"><el-tag :type="detail.in_heat?'warning':'info'" size="small">{{detail.in_heat?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="创建人">ID: {{detail.user_id}}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{formatDate(detail.created_at)}}</el-descriptions-item>
          <el-descriptions-item label="驱虫时间">{{formatDate(detail.deworming_date)}}</el-descriptions-item>
          <el-descriptions-item label="疫苗时间">{{formatDate(detail.vaccination_date)}}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="3">{{detail.remark||'-'}}</el-descriptions-item>
        </el-descriptions>

        <!-- 行为与性格 -->
        <h4 style="margin:0 0 12px;color:#606266">行为与性格</h4>
        <el-descriptions :column="3" border style="margin-bottom:24px">
          <el-descriptions-item label="对犬攻击性"><el-tag :type="detail.aggressive_to_pets?'danger':'success'" size="small">{{detail.aggressive_to_pets?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="对人攻击性"><el-tag :type="detail.aggressive_to_humans?'danger':'success'" size="small">{{detail.aggressive_to_humans?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="对狗攻击性"><el-tag :type="detail.aggressive_to_dogs?'danger':'success'" size="small">{{detail.aggressive_to_dogs?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="对人攻击"><el-tag :type="detail.aggressive_to_human?'danger':'success'" size="small">{{detail.aggressive_to_human?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="护食"><el-tag :type="detail.protect_food?'warning':'info'" size="small">{{detail.protect_food?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="护玩具"><el-tag :type="detail.protect_toys?'warning':'info'" size="small">{{detail.protect_toys?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="护领地"><el-tag :type="detail.protect_territory?'warning':'info'" size="small">{{detail.protect_territory?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="社交补充">{{detail.social_supplement||'-'}}</el-descriptions-item>
          <el-descriptions-item label="敏感声音"><el-tag :type="detail.sensitive_to_sound?'warning':'info'" size="small">{{detail.sensitive_to_sound?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="烟花反应">{{detail.firework_reaction||'-'}}</el-descriptions-item>
          <el-descriptions-item label="疾病史"><el-tag :type="detail.has_history?'warning':'info'" size="small">{{detail.has_history?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="疾病详情" :span="2">{{detail.history_detail||'-'}}</el-descriptions-item>
        </el-descriptions>

        <!-- 喂养习惯 -->
        <h4 style="margin:0 0 12px;color:#606266">喂养习惯</h4>
        <el-descriptions :column="3" border style="margin-bottom:24px">
          <el-descriptions-item label="喂食次数">{{detail.feed_count||'-'}}次/天</el-descriptions-item>
          <el-descriptions-item label="喂食量">{{detail.feed_amount||'-'}}</el-descriptions-item>
          <el-descriptions-item label="食物成分">{{detail.feed_ingredient||'-'}}</el-descriptions-item>
          <el-descriptions-item label="饮用水">{{detail.water_type||'-'}}</el-descriptions-item>
          <el-descriptions-item label="喂食时间">{{detail.feed_time||'-'}}</el-descriptions-item>
          <el-descriptions-item label="零食频率">{{detail.snack_freq||'-'}}</el-descriptions-item>
          <el-descriptions-item label="禁忌食物"><el-tag :type="detail.has_taboo?'warning':'info'" size="small">{{detail.has_taboo?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="禁忌详情" :span="2">{{detail.taboo_detail||'-'}}</el-descriptions-item>
        </el-descriptions>

        <!-- 外出与活动 -->
        <h4 style="margin:0 0 12px;color:#606266">外出与活动</h4>
        <el-descriptions :column="3" border style="margin-bottom:24px">
          <el-descriptions-item label="外出次数">{{detail.outdoor_count||'-'}}次/天</el-descriptions-item>
          <el-descriptions-item label="外出时长">{{detail.outdoor_duration||'-'}}</el-descriptions-item>
          <el-descriptions-item label="外出时段">{{detail.outdoor_time_range||'-'}}</el-descriptions-item>
          <el-descriptions-item label="喜欢玩具"><el-tag :type="detail.like_toys?'success':'info'" size="small">{{detail.like_toys?'是':'否'}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="玩具类型" :span="2">{{detail.toy_types||'-'}}</el-descriptions-item>
        </el-descriptions>

        <!-- 健康状况 -->
        <h4 style="margin:0 0 12px;color:#606266">健康状况</h4>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="肠胃状况">{{detail.stomach_condition||'-'}}</el-descriptions-item>
          <el-descriptions-item label="皮肤状况">{{detail.skin_condition||'-'}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <div v-else style="text-align:center;padding:40px;color:#999">暂无数据</div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import * as api from '../../api/petProfile';

const species = ref([]);

const formatDate = (v) => v ? v.substring(0, 10) : '-';

const route = useRoute();
const filterUserId = route.query.user_id || '';
const searchQuery = ref('');
const filterSpeciesId = ref('');
const list = ref([]);
const loading = ref(false);
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 });
const detailDialog = ref(false);
const detail = ref({});

const fetchData = async () => {
  loading.value = true;
  try {
    const params = { page: pagination.current_page, per_page: pagination.per_page };
    if (filterUserId) params.user_id = filterUserId;
    if (searchQuery.value) params.search = searchQuery.value;
    if (filterSpeciesId.value) params.species_id = filterSpeciesId.value;
    const r = await api.getPetArchives(params);
    list.value = r.data || [];
    pagination.current_page = r.pagination?.current_page || 1;
    pagination.total = r.pagination?.total || 0;
  } catch {} finally { loading.value = false; }
};

const showDetail = async (row) => {
  detail.value = row;
  // 尝试加载关联的品类和品种
  try {
    const r = await api.getPetArchive(row.id);
    if (r.data) detail.value = r.data;
  } catch {}
  detailDialog.value = true;
};

onMounted(async () => {
  try { const r = await api.getPetSpecies(); species.value = r.data || []; } catch {}
  fetchData();
});
</script>

<style scoped>
.header-actions { display: flex; gap: 12px; align-items: center; }
</style>
